import { message } from "antd";
import React from "react";
import zipcodes from 'zipcodes';
import tzlookup from "tz-lookup";

export const capitalizeFirstLetter = (string) => {
  if (!string || typeof string !== 'string') return "";
  return string.charAt(0).toUpperCase() + string?.slice(1);
};

export const checkStrongPassword = (password) => {
  const strongRegex = new RegExp(
    "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})(?=.*[!@#$%^&*])"
  );
  return strongRegex.test(password);
};

export const specialtyOptions = [
  { value: "cardiology", label: "Cardiology" },
  { value: "urology", label: "Urology" },
  { value: "dermatology", label: "Dermatology" },
  { value: "endocrinology", label: "Endocrinology" },
  { value: "family_medicine", label: "Family Medicine" },
  { value: "gastroenterology", label: "Gastroenterology" },
  { value: "internal_medicine", label: "Internal Medicine" },
  { value: "neurology", label: "Neurology" },
  { value: "obstetrics", label: "Obstetrics & Gynecology" },
  { value: "anesthesiology", label: "Anesthesiology" },
  { value: "ophthalmology", label: "Ophthalmology" },
  { value: "orthopedics", label: "Orthopedic Surgery" },
  { value: "pediatrics", label: "Pediatrics" },
  { value: "emergency_medicine", label: "Emergency Medicine" },
  { value: "plastic_surgery", label: "Plastic Surgery" },
  { value: "pulmonology", label: "Pulmonology" },
  { value: "general_surgery", label: "General Surgery" },
  { value: "neurosurgery", label: "Neurosurgery" },
];

export const limitedcountry = [
  {
    "name": "United States",
    "dial_code": "1",
    "code": "US"
  },
  // {
  //   "name": "Canada",
  //   "dial_code": "1",
  //   "code": "CA"
  // },
];

export const titleFormat = (text) => {
  if(!text) return ''
  return text
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};


export const  formatDuration = (seconds) => {
  if (seconds < 60) {
    return `${seconds}s`;
  }

  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')} min`;
}

export const validateZipCode = async (zipCode, countryCode) => {
  if (!zipCode || !countryCode) return {
    message: 'ZIP code or country is missing',
    data: null,
  };
  const zipData = zipcodes.lookup(zipCode);
  if (!zipData) return {
    message: 'Invalid ZIP code',
    data: null
  };
  if ((zipData.country || '').toUpperCase() !== countryCode.toUpperCase()) {
    return {
      message: `Invalid ZIP for selected country (${countryCode})`,
      data: null
    }
  }
  const timeZone = tzlookup(zipData.latitude, zipData.longitude);

  const now = new Date();

  // Create date strings in both UTC and the local timezone
  const utcDate = new Date(now.toLocaleString('en-US', { timeZone: 'UTC' }));
  const localDate = new Date(now.toLocaleString('en-US', { timeZone }));

  const offsetMinutes = (localDate - utcDate) / 60000;
  const offsetHours = offsetMinutes / 60;

  const gmtOffset = `GMT${offsetHours >= 0 ? '+' : ''}${offsetHours}`;

  const combined = `${tzlookup(zipData.latitude, zipData.longitude)} (${gmtOffset})`

  let cityState = zipData.city;
  if (zipData.state) cityState += ', ' + zipData.state;
  return {
    message: 'ZIP is valid',
    data: combined
  }
};

export const secretKey ="3f02993c9d677e955478c979ed95b0cec2a1d80bcef204d7054ca0a9e7ece841";
export const secretIv = "AA752287D85B53C757BF32B759685";